export const settings = {
  accountCompletionModal: {
    action: {
      complete: 'Terminer',
      next: 'Suivant',
      save: 'Enregistrer',
    },
    description: 'Complétez vos données pour pouvoir commencer rapidement à facturer.',
    financialInfo: {
      description: 'Saisissez votre numéro de compte ci-dessous.',
      tab: 'Coordonnées bancaires',
    },
    frameworkAgreement: {
      error: 'Une erreur s’est produite lors de la signature de votre contrat.',
      tab: 'Contrat-cadre',
    },
    peppol: {
      checkAgain: 'Vérifier ma boîte de réception Peppol',
      description:
        '<paragraph>Pour envoyer des factures via Creative Shelter, vous avez besoin d’une <bold>boîte de réception Peppol active</bold>. Vous n’en avez pas encore pour le moment.</paragraph>\n<paragraph>Sans boîte de réception Peppol, nous ne pouvons pas envoyer votre facture. Activez d’abord votre boîte de réception Peppol auprès d’un fournisseur agréé.</paragraph>\n<paragraph>Dès que votre boîte de réception Peppol est activée, nous pouvons retrouver automatiquement votre identifiant Peppol. C’est déjà fait ? Vous pouvez relancer la vérification ci-dessous.</paragraph>',
      tab: 'Boîte de réception Peppol',
    },
    successModal: {
      createFirstInvoice: 'Créer votre première facture',
      description: 'Vous êtes maintenant prêt·e à envoyer votre facture ou votre devis !',
      title: 'Votre compte est prêt',
    },
    title: 'Complétez votre compte',
    vatRegulation: {
      error: 'Une erreur s’est produite lors de l’enregistrement de votre régime de TVA.',
      tab: 'Régime de TVA',
    },
  },
  alerts: {
    brands: {
      successCreated: 'Votre nom commercial a été créé.',
      successDeleted: 'Votre nom commercial a été supprimé.',
      successFavorite: 'Votre nom commercial favori a été modifié.',
      successUpdated: 'Votre nom commercial a été modifié.',
    },
    community: {
      errorProfilePictureDeleted:
        'Une erreur s’est produite lors de la suppression de votre photo de profil Community. Contactez service@creativeshelter.be si le problème persiste.',
      errorProfilePictureTooLarge: 'L’image que vous souhaitez téléverser ne peut pas dépasser 5 Mo.',
      errorProfilePictureUploaded:
        'Une erreur s’est produite lors du téléversement de votre photo de profil Community. Contactez service@creativeshelter.be si le problème persiste.',
      errorUpdated:
        'Une erreur s’est produite lors de la mise à jour de votre profil Community. Contactez service@creativeshelter.be si le problème persiste.',
      successProfilePictureDeleted: 'Votre photo de profil Community a été supprimée.',
      successProfilePictureUploaded: 'Votre photo de profil Community a été modifiée.',
    },
    customConditions: {
      successDeleted: 'Vos conditions générales personnalisées ont été supprimées.',
    },
    errorActivities: 'Une erreur s’est produite lors de l’enregistrement de vos activités.',
    errorPersonalInfo: 'Une erreur s’est produite lors de l’enregistrement de vos informations de profil.',
    integrations: {
      successAccountantLinked: 'Votre comptable a été ajouté.',
      successAccountantUnlinked: 'Votre comptable a été supprimé.',
      successBillitPaired: 'Votre logiciel de comptabilité a été ajouté.',
      successCashacaPaired: 'Cashaca a été connecté.',
      successForwardingEmailLinked: 'L’adresse e-mail a été ajoutée.',
      successForwardingEmailUnlinked: 'L’adresse e-mail a été supprimée.',
    },
    invalidFields: 'Tous les champs ne sont pas correctement remplis. Vérifiez les champs indiqués.',
    numberingSeries: {
      duplicateFormat: 'Vous avez déjà utilisé le format de cette série de numérotation. Pouvez-vous en choisir un nouveau ?',
      successCreated: 'Votre série de numérotation a été créée.',
      successDeleted: 'Votre série de numérotation a été supprimée.',
      successUpdated: 'Votre série de numérotation a été modifiée.',
    },
    successUpdated: 'Vos paramètres ont été enregistrés.',
    validFinancialInfo: 'Coordonnées bancaires valides',
  },
  breadcrumb: {
    documents: 'Documents',
    invitations: 'Invitations',
    pricing: 'Commission',
    root: 'Paramètres',
  },
  documents: {
    headers: {
      name: 'Nom du fichier',
      type: 'Type',
    },
    title: 'Documents',
  },
  edit: 'Modifier',
  fields: {
    accountantEmail: {
      label: 'Adresse e-mail de votre comptable',
      placeholder: 'Adresse e-mail',
    },
    activities: {
      other: {
        label: 'Indiquez ici vos autres activités créatives',
      },
      primary: {
        label: 'Activité principale',
      },
      secondary: {
        label: 'Autres activités',
      },
    },
    brandId: {
      label: 'Nom commercial',
    },
    brandName: {
      label: 'Nom commercial',
      placeholder: 'Votre nom commercial',
    },
    city: {
      label: 'Commune',
    },
    color: {
      label: 'Couleur',
    },
    communityDescription: {
      label: 'Présentez-vous brièvement et/ou présentez vos activités',
    },
    communityEmail: {
      label: 'Adresse e-mail publique',
    },
    communityLinks: {
      label: 'Liens',
      placeholders: {
        behance: 'https://www.behance.net/',
        facebook: 'https://www.facebook.com/',
        instagram: 'https://www.instagram.com/',
        linkedIn: 'https://www.linkedin.com/in/',
        website: 'https://',
      },
    },
    communityOpenToWork: {
      label: 'Je suis disponible pour des missions',
    },
    communityRegion: {
      label: 'Région',
      placeholder: 'Non spécifiée',
    },
    companyName: {
      label: 'Nom de l’entreprise',
    },
    currentPassword: {
      label: 'Mot de passe actuel',
    },
    email: {
      label: 'Adresse e-mail',
      placeholder: 'Adresse e-mail',
    },
    firstName: {
      label: 'Prénom',
      placeholder: 'Prénom',
    },
    forwarding: {
      alerts: {
        billtobox:
          'Pouvez-vous ajouter « administratie@creativeshelter.be » comme adresse e-mail connue dans Billtobox ? Tout se déroulera alors sans problème !',
      },
      frequency: {
        label: 'Fréquence',
        options: {
          instant: 'Par facture ou note de crédit (.pdf/.xml)',
          monthly: 'Par mois (.zip)',
          quarterly: 'Par trimestre (.zip)',
        },
        tooltip:
          'Si vous avez indiqué un logiciel de comptabilité, choisissez l’option qui transmet un fichier PDF et XML par facture ou note de crédit.',
      },
      platformEmail: {
        label: 'Adresse e-mail de votre compte Accountable',
        tooltip: 'Grâce à cette adresse e-mail, Accountable reconnaît à quel compte appartiennent vos factures et vos notes de crédit.',
      },
    },
    lang: {
      label: 'Langue',
    },
    lastName: {
      label: 'Nom de famille',
      placeholder: 'Nom de famille',
    },
    logo: {
      error: {
        delete: 'Une erreur s’est produite lors de la suppression du logo. Veuillez réessayer plus tard.',
        tooLarge: 'Le logo que vous essayez de téléverser ne peut pas dépasser 5 Mo.',
        upload: 'Une erreur s’est produite lors du téléversement du logo.',
      },
      label: 'Logo du nom commercial',
      tooltip:
        'Si vous sélectionnez ce nom commercial lors de l’établissement d’un document, ce logo sera utilisé à la place de celui de votre nom commercial principal.',
    },
    mainOccupation: {
      label: 'Votre statut d’indépendant',
      options: {
        '0': 'Activité complémentaire',
        '1': 'Activité principale',
      },
    },
    newPassword: {
      label: 'Nouveau mot de passe',
    },
    newPasswordConfirmation: {
      label: 'Confirmer le nouveau mot de passe',
    },
    number: {
      label: 'Numéro',
    },
    numberingSeries: {
      blocker:
        'Voulez-vous vraiment quitter cette page ? Les modifications apportées à votre série de numérotation n’ont pas été enregistrées.',
      format: {
        amountOfDigits: {
          label: 'Nombre de chiffres',
          option: '{{amountOfDigits}} chiffres',
        },
        lengthWarning: 'Nous vous conseillons de limiter la longueur du numéro à {{limit}} caractères.',
        nextNumber: 'Le prochain numéro de cette série est <strong>{{number}}</strong>',
        prefixText: {
          label: 'Préfixe',
        },
        separator: {
          label: 'Séparateur',
          none: 'Aucun',
        },
        suffixText: {
          label: 'Suffixe',
        },
        useSuffix: 'Utiliser un suffixe',
        year: {
          label: 'Année/mois',
          options: {
            YY: 'Année courte ({{yearMonth}})',
            YYMM: 'Année courte + mois ({{yearMonth}})',
            YYYY: 'Année ({{yearMonth}})',
            YYYYMM: 'Année + mois ({{yearMonth}})',
            none: 'Aucun',
          },
        },
      },
      name: {
        label: 'Nom',
        placeholder: 'P. ex. Factures de vente',
        tooltip: 'Donnez un nom à votre série de numérotation pour la reconnaître rapidement.',
      },
      resetInterval: {
        description: 'Remettre automatiquement le compteur à 1.',
        label: 'Redémarrer le compteur',
        options: {
          monthly: 'Chaque mois',
          never: 'Jamais',
          yearly: 'Chaque année',
        },
      },
      startAt: {
        label: 'Numéro de départ',
      },
      type: {
        label: 'Type',
        options: {
          both: 'Factures et notes de crédit',
          credit_notes: 'Notes de crédit',
          invoices: 'Factures',
        },
        tooltip:
          'Dans votre comptabilité, il existe deux types de documents importants : vos factures et vos notes de crédit. Vous pouvez utiliser une seule série de numérotation pour les deux, mais vous pouvez aussi les séparer. C’est à vous de choisir.',
      },
    },
    phone: {
      label: 'Numéro de téléphone',
      placeholder: '+32 499 99 99 99',
    },
    street: {
      label: 'Rue',
    },
    vatID: {
      label: 'Numéro de TVA',
    },
    zipcode: {
      label: 'Code postal',
    },
  },
  general: {
    customConditions: {
      create: 'Nouvelles conditions',
      delete: {
        action: 'Supprimer les conditions générales personnalisées',
        description: 'Voulez-vous vraiment supprimer les conditions générales personnalisées « {{name}} » ?',
        title: 'Supprimer les conditions générales personnalisées',
      },
      description: 'Consultez ici l’aperçu de toutes vos conditions générales personnalisées ou créez-en de nouvelles.',
      table: {
        actions: {
          creatingPdf: 'Génération du PDF…',
          delete: 'Supprimer',
          view: 'Consulter',
        },
        name: 'Nom',
      },
      title: 'Conditions générales personnalisées',
      wizard: {
        already_agreement: {
          question: 'Avez-vous déjà convenu avec votre client de la manière dont votre œuvre peut être utilisée ?',
        },
        already_agreement_no: {
          question: 'Pas de souci ! À l’aide des questions suivantes, vous déterminez ce que votre client peut faire de votre œuvre.',
        },
        already_agreement_no_paper: {
          question: 'Pas de souci ! À l’aide des questions suivantes, nous les mettons par écrit pour vous.',
        },
        already_agreement_paper: {
          question: 'Avez-vous ces accords par écrit ?',
        },
        already_agreement_yes_paper: {
          question:
            "Parfait, les bons comptes font les bons amis. Indiquez dans le profil du client que vous avez déjà un contrat existant et transmettez-le-nous par e-mail (<a href='mailto:administratie@creativeshelter.be'>administratie@creativeshelter.be</a>). Nous examinerons volontiers ce contrat pour vous et le cosignerons en tant que tierce partie.",
        },
        common_answers: {
          close: 'OK, fermer l’assistant',
          next: 'OK, question suivante',
          no: 'Non',
          ok: 'OK',
          previous: 'Question précédente',
          start_questions: 'OK, commencer les questions',
          yes: 'Oui',
        },
        modify_how: {
          options: {
            '0': 'En l’adaptant/modifiant par l’ajout et/ou la suppression d’éléments.',
            '1': 'En la traduisant/transposant.',
          },
          question: 'Comment votre œuvre peut-elle être adaptée ou modifiée ?',
        },
        overview: {
          finish: 'OK, créer mes conditions générales personnalisées.',
          name: {
            label:
              'Indiquez ici le nom de vos nouvelles conditions générales personnalisées. Il peut contenir le nom du client ou les accords spécifiques.',
            placeholder: 'Par exemple « Droit d’utilisation Benelux 1 an »',
          },
          question: 'Merci, c’était la dernière question ! Voici encore un aperçu de vos réponses :',
        },
        reproduce_how: {
          options: {
            '0': 'De quelque manière que ce soit, sous quelque forme que ce soit, par toutes les techniques et sur tous les supports.',
            '1': 'Sous une forme spécifique.',
            '2': 'Sous forme électronique sur un support d’information fixe.',
            '3': 'Sous forme électronique sur un support d’information en ligne.',
          },
          other_placeholder: 'Pouvez-vous préciser sous quelle forme ?',
          question: 'De quelle manière votre œuvre peut-elle être reproduite ?',
        },
        reproduce_how_many: {
          options: {
            '0': 'Illimité',
            '1': 'Limité',
          },
          other_placeholder: 'Précisez le nombre',
          question: 'En combien d’exemplaires votre œuvre peut-elle être reproduite ?',
        },
        share_how: {
          options: {
            '0': 'Publier dans …',
            '1': 'Mettre à disposition via …',
            '2': 'Intégrer dans un livre, un catalogue, …',
            '3': 'Comme matériel promotionnel et à des fins commerciales.',
          },
          other_placeholder: 'Précisez',
          question: 'De quelle manière votre œuvre peut-elle être communiquée au public ?',
        },
        start: {
          description: 'Suivez l’assistant ci-dessous pour composer vos propres conditions générales personnalisées.',
          ok: 'OK, démarrer l’assistant',
          title: 'Créez vos conditions générales personnalisées',
        },
        thanks: {
          close: 'Fermer l’assistant',
          explanation:
            'Créez votre facture et sélectionnez le nom de vos CG personnalisées en bas du menu déroulant « accord sur les droits d’auteur ». Vos CG personnalisées sont automatiquement reprises à l’article 8 (8.1 à 8.3) de l’annexe que nous envoyons à votre client avec notre facture. Le champ « conditions particulières » de notre facture à votre client fait également référence aux CG personnalisées.',
          question:
            'Vos conditions générales personnalisées sont en cours de création. Vous pourrez bientôt les consulter et les utiliser lors de la création de votre facture !',
          subtitle: 'Comment commencer ?',
        },
        transfer_copyright: {
          question: 'Voulez-vous céder à votre client vos droits d’auteur sur votre œuvre ?',
        },
        transfer_copyright_no: {
          question: 'OK, super ! Vous devez alors indiquer ce qui peut être fait de votre œuvre.',
        },
        transfer_copyright_yes: {
          question: 'OK, parfait ! Choisissez alors « cession » lors de la création d’un devis ou d’une facture.',
        },
        use_how: {
          options: {
            '0': 'Faire des reproductions',
            '1': 'Communiquer au public',
            '2': 'Adapter/modifier',
          },
          question: 'Que peut faire votre client de votre œuvre ?',
        },
        use_how_long: {
          options: {
            '0': 'Durée totale',
            '1': 'Autre période',
          },
          other_placeholder: 'Précisez la période',
          question: 'Combien de temps votre client peut-il utiliser votre œuvre ?',
        },
        use_where: {
          options: {
            '0': 'Belgique',
            '1': 'Europe',
            '2': 'Le monde entier',
            '3': 'Autre',
          },
          other_placeholder: 'Par exemple Benelux',
          question: 'Où votre client peut-il utiliser votre œuvre ?',
        },
      },
    },
    description: 'Modifiez la mise en page et le fonctionnement de votre plateforme.',
    email: {
      bcc: {
        description:
          'Vous êtes alors en copie cachée de tous les e-mails que nous envoyons à vos clients, des nouveaux devis, factures et notes de crédit jusqu’aux rappels de paiement des factures.',
        title: 'Me mettre en Cci de tous les e-mails envoyés à mes clients',
      },
      description: 'Choisissez ici les e-mails et notifications que vous souhaitez recevoir',
      followUpEnabled: {
        description: 'Recevez une notification en cas de nouvelles sur le suivi du paiement d’une facture échue',
        title: 'Nouvelles du suivi des paiements',
      },
      invitationReminder: {
        description: 'Recevez un rappel lorsque le collègue freelance que vous avez invité reçoit à son tour un rappel pour s’inscrire.',
        title: 'Rappel concernant les invitations envoyées',
      },
      jobPostUpdates: {
        description:
          'Recevez chaque semaine un aperçu des nouvelles missions (pas encore pourvues) en fonction de vos activités principales et secondaires.',
        title: 'Aperçu hebdomadaire des nouvelles missions',
      },
      nettoSaved: {
        description:
          'Recevez un aperçu de ce que vous économisez chaque mois en utilisant Creative Shelter. Vous voyez ainsi noir sur blanc ce que vous gagnez en plus en valorisant vos droits d’auteur.',
        title: 'E-mail mensuel sur les économies nettes',
      },
      title: 'E-mails et notifications',
    },
    numberingSeries: {
      add: 'Nouvelle série de numérotation',
      delete: {
        description: 'Voulez-vous vraiment supprimer « {{numberingSeries}} » ?',
        title: 'Supprimer la série de numérotation',
      },
      description:
        'Système de numérotation automatique de vos factures et notes de crédit. Des questions ou envie d’en savoir plus ? <a href="https://knowledge.creativeshelter.be/wat-is-een-nummeringreeks-en-hoe-stel-ik-deze-in" target="_blank">C’est par ici</a>.',
      edit: {
        format: 'Modifier le format/les options',
        name: 'Modifier le nom/le type',
      },
      headers: {
        name: 'Nom',
        nextNumber: 'Numéro suivant',
        type: 'Type',
      },
      title: 'Séries de numérotation',
    },
    themeInvoice: {
      colorTheme: {
        helpText: 'Choisissez une combinaison de couleurs pour les documents envoyés à vos clients.',
        subtitle: 'Thème de couleurs',
      },
      logo: {
        helpText: 'Téléversez ici le logo de votre entreprise individuelle.',
      },
      title: 'Thème de la facture',
    },
    title: 'Paramètres',
  },
  header: {
    save: 'Enregistrer les modifications',
    title: 'Paramètres',
  },
  imageUpload: {
    logo: {
      delete: 'Supprimer le logo',
      label: 'Logo',
      upload: 'Téléverser le logo',
    },
    profilePicture: {
      delete: 'Supprimer la photo',
      label: 'Photo de profil',
      upload: 'Téléverser une photo',
    },
  },
  integrations: {
    accountant: {
      current: 'Le comptable ci-dessous a été ajouté à votre compte :',
      description:
        'En ajoutant votre comptable, vous lui donnez accès à vos factures et documents via la plateforme Credit de Creative Shelter.',
      pair: 'Ajouter',
      requested: 'Le comptable ci-dessous a demandé l’accès à votre compte :',
      title: 'Donnez accès à votre comptable',
      unpair: 'Supprimer',
    },
    description: 'Connectez ici votre compte Creative Shelter à des services externes.',
    externalSystems: {
      createAccount: 'Créer un compte',
      description:
        'Connectez ici votre logiciel de comptabilité pour transmettre automatiquement vos factures et notes de crédit. Attention : il ne s’agit pas d’une connexion à votre boîte de réception Peppol.',
      pairWith: 'Connecter avec {{ system }}',
      paired: 'Connecté',
      peppolWarning:
        'Les factures et notes de crédit envoyées via Peppol peuvent arriver en double dans votre connexion. Vérifiez les paramètres de votre logiciel de comptabilité pour éviter un double traitement.',
      systems: {
        billit: {
          description:
            'Vous créez aussi parfois des factures non créatives en plus de vos factures créatives ? Cette intégration vous permet de créer facilement ces factures non créatives et de les lier à votre compte Creative Shelter.',
          name: 'Billit',
        },
        cashaca: {
          description:
            'Cashaca simplifie votre comptabilité. Idéal pour les indépendants dont le chiffre d’affaires est inférieur à 500 000 €.',
          modal: {
            apiToken: 'Code API de Cashaca',
            description:
              'Saisissez ici votre code API personnel de Cashaca.<br/>Vous n’avez pas encore de compte Cashaca ? <a href="https://app.cashaca.be/gebruikers/registreer?utm_source=creativeshelter" target="_blank">Inscrivez-vous ici</a>.',
          },
          name: 'Cashaca',
        },
        dexxter: {
          alerts: {
            error: 'Une erreur s’est produite lors de la connexion de votre compte Dexxter.',
            success: 'Vous êtes connecté à votre compte Dexxter.',
          },
          description:
            'Vos factures et notes de crédit, automatiquement dans Dexxter. La plateforme pour tenir vous-même la comptabilité de votre entreprise individuelle, à portée de main.',
          modal: {
            description:
              'Transmettez automatiquement vos factures et notes de crédit à Dexxter en deux étapes rapides :<ol><li>Allez dans vos paramètres et cliquez sur « <dexxterLink href="https://go.dexxter.be/user-settings/general/company-settings">Général</dexxterLink> ». Cochez l’option « Activer les droits d’auteur » et enregistrez.</li><li>Allez dans « Revenus » et cliquez sur « <dexxterLink href="https://go.dexxter.be/income-documents">Boîte de réception</dexxterLink> ». Dans la boîte de réception, cliquez sur « Voir le mode de livraison » et copiez l’adresse e-mail de votre boîte aux lettres numérique. Collez-la ci-dessous.</li></ol>',
            emailAddress: {
              placeholder: 'income.xxxxxxxxxxxxxxxx',
              suffix: '@inbound.dexxter.be',
              validatePrefix: 'L’adresse e-mail doit commencer par « income. ».',
              validateSuffix: 'Indiquez uniquement ce qui se trouve avant le « @ ».',
            },
            title: 'Connecter avec Dexxter',
            titleTooltip:
              'Plus d’infos <faqLink href="https://www.creativeshelter.be/knowledge-hub/hoe-stuur-ik-mijn-facturen-automatisch-door-naar-dexxter">dans notre FAQ</faqLink>.',
          },
          name: 'Dexxter',
          tag: 'Obtenez 25 € de réduction',
        },
      },
      title: 'Connexion à des systèmes externes',
    },
    forwarding: {
      add: 'Ajouter un destinataire',
      blocker:
        'Voulez-vous vraiment quitter cette page ? Les modifications apportées à votre adresse de transfert n’ont pas été enregistrées.',
      deleteModal: {
        confirm: 'Oui, j’en suis sûr·e.',
        description: 'Voulez-vous vraiment arrêter de transmettre vos factures et notes de crédit à {{email}} ?',
        dexxter: {
          confirm: 'Supprimer la connexion',
          description: 'Voulez-vous vraiment arrêter de transmettre automatiquement vos factures et notes de crédit à Dexxter ?',
          title: 'Supprimer la connexion Dexxter',
        },
        title: 'Arrêter le transfert automatique',
      },
      description:
        'Transmettez automatiquement vos factures et notes de crédit à votre comptable ou à votre logiciel de comptabilité. <a href="https://www.creativeshelter.be/knowledge-hub/kan-ik-mijn-documenten-automatisch-doorsturen-naar-mijn-accountant" target="_blank">Nous vous l’expliquons ici.</a>',
      peppol: {
        description:
          'Vous recevez toutes vos factures dans votre boîte de réception Peppol. Il n’est plus nécessaire de les transmettre automatiquement ou de connecter un système externe, sauf demande spécifique.',
        title: 'Peppol est activé',
      },
      title: 'Transfert automatique',
    },
    pair: 'Connecter',
    peppol: {
      actions: {
        checkAgain: 'Vérifier à nouveau',
      },
      confirmExtraIntegration: {
        cancel: 'Ne pas connecter',
        confirm: 'Connecter quand même',
        description:
          'Vous recevez déjà vos factures dans votre boîte de réception Peppol. Une connexion supplémentaire n’est généralement pas nécessaire, sauf si votre comptable ou votre logiciel de comptabilité le demande spécifiquement. Voulez-vous vraiment continuer ?',
        title: 'Besoin d’une connexion supplémentaire ?',
      },
      description:
        'C’est la manière structurée d’envoyer et de recevoir des documents. Et surtout : c’est obligatoire depuis 2026, pour vous aussi.',
      disclaimerSelfBillingUnsupported:
        '<bold>Depuis le 1er janvier 2026, nous envoyons vos factures via Peppol, vous êtes donc en règle avec la loi.</bold><br>\nVotre boîte de réception Peppol ne prend <strong>pas (encore) en charge l’autofacturation</strong>. Vos factures n’arrivent donc peut-être pas encore automatiquement dans votre comptabilité. <strong>En guise d’alternative</strong>, vous pouvez aussi recevoir automatiquement vos factures dans votre comptabilité via notre <strong>paramètre « transfert automatique »</strong>.',
      fields: {
        peppolId: {
          empty: 'Pas encore d’identifiant Peppol',
          label: 'Identifiant Peppol',
          tooltip:
            'Nous avons trouvé cet identifiant Peppol pour vous. Il n’est pas correct ? <email href="mailto:service@creativeshelter.be">Envoyez-nous un e-mail</email> et nous le corrigerons pour vous.',
        },
        status: {
          label: 'Statut',
          options: {
            Active: 'Activé',
            ActiveSelfBillingFallback: 'Autofacturation non activée',
            NotRegistered: 'Aucun identifiant Peppol trouvé',
          },
        },
      },
      title: 'Peppol',
    },
    processing: 'Nous récupérons vos données',
    title: 'Intégrations',
    unpair: 'Déconnecter',
  },
  nps: {
    ariaLabelTextarea: 'Donnez votre avis ici',
    eyebrow: 'Votre avis compte',
    placeholderTextarea: 'Donnez votre avis ici…',
    sendFeedback: 'Envoyer votre avis',
    titleStepOne: 'Dans quelle mesure recommanderiez-vous Creative Shelter à d’autres freelances ?',
    titleStepThree: 'Merci ! Nous allons tenir compte de votre avis !',
  },
  profile: {
    activities: {
      title: 'Activités',
      warnings: {
        stylingAndInterior: {
          body: 'Depuis 2024, les prestations créatives de stylisme et d’architecture d’intérieur ne donnent plus toutes droit à une rémunération en droits d’auteur. L’interprétation de la loi est plus stricte que la loi elle-même. Vous doutez que votre prestation soit éligible ? <a href="mailto:administratie@creativeshelter.be?subject=Komen mijn prestaties voor styling/interieur nog in aanmerking?" target="_blank">Envoyez-nous un e-mail</a> et nous examinerons cela avec vous. Pour d’autres activités créatives, vous restez éligible.',
          title: 'Important ! Styliste ou architecte d’intérieur ? Lisez la suite.',
        },
      },
    },
    brands: {
      add: 'Ajouter un nom commercial',
      delete: {
        description: 'Voulez-vous vraiment supprimer « {{brand}} » ?',
        title: 'Supprimer le nom commercial',
      },
      description: 'Consultez, créez et modifiez vos noms commerciaux.',
      edit: 'Modifier le nom commercial',
      favorite: {
        markAsFavorite: 'Marquer comme favori',
        removeFavorite: 'Retirer des favoris',
      },
      headers: {
        color: 'Couleur du nom commercial',
        email: 'Adresse e-mail',
        logo: 'Logo',
        name: 'Votre nom commercial',
      },
      logoAdd: 'Ajouter un logo',
      logoEdit: 'Modifier le logo',
      mainBrand: 'Nom commercial principal',
      title: 'Noms commerciaux',
    },
    community: {
      communityHidden:
        'Votre accès à la Community a été désactivé. Pour plus d’infos, n’hésitez pas à nous <a href="mailto:admin@creativeshelter.be?subject=Geblokkeerde toegang Community" target="_blank">envoyer un e-mail</a>.',
      description: 'Modifiez ici votre profil Community',
      title: 'Community',
      visibleInCommunity: 'Visible dans la Community',
    },
    financial: {
      bank: 'Nom de la banque',
      bic: 'BIC/SWIFT',
      check: 'Vérifier',
      error: {
        foreignIban:
          'Une erreur s’est produite lors de la récupération de vos informations bancaires. Pouvez-vous les compléter vous-même ?',
        general: 'Une erreur s’est produite lors de l’enregistrement de votre numéro de compte.',
      },
      iban: 'Numéro de compte',
      title: 'Coordonnées bancaires',
    },
    info: {
      companyTitle: 'Données de votre entreprise individuelle',
      kboDescription: 'Ces données proviennent de la base de données de la BCE.',
      language: {
        en: 'Anglais',
        fr: 'Français',
        nl: 'Néerlandais',
      },
      refreshKboInformation: {
        action: 'Actualiser les données',
        lastUpdated: 'Mis à jour depuis la BCE {{timeAgo}}',
        tooltip:
          'Nous récupérons les données directement auprès de la <kboLink>Banque-Carrefour des Entreprises</kboLink> (BCE en abrégé). Elles ne sont plus à jour ? Vous pouvez alors récupérer ici les données les plus récentes. Uniquement possible si les données datent de plus de 7 jours.',
        unavailable_one: 'Vous pourrez à nouveau actualiser vos données dans 1 jour.',
        unavailable_other: 'Vous pourrez à nouveau actualiser vos données dans {{count}} jours.',
      },
      subsections: {
        kbo: 'Données de l’entreprise',
        personal: 'Informations personnelles',
      },
      title: 'Informations du profil',
    },
    password: {
      edit: 'Changer le mot de passe',
      title: 'Changer le mot de passe',
    },
    title: 'Profil',
    vatRegulation: {
      description: 'Vous trouverez ici des informations supplémentaires sur votre régime de TVA actuel.',
      edit: 'Modifier',
      help: 'Indiquez le régime de TVA que vous appliquez. Il détermine si la TVA est facturée sur vos factures. Les petites entreprises dont le chiffre d’affaires est inférieur à 25 000 € peuvent appliquer le régime standard de franchise de TVA. Vous pouvez en faire la demande vous-même. Vous trouverez plus d’informations <a href="https://knowledge.creativeshelter.be/wat-is-de-btw-vrijstellingsregeling-en-bestaan-er-nog-andere-regelingen" target="_blank">ici</a>.',
      info: {
        none: 'Vous n’avez pas encore indiqué votre régime de TVA.',
        vatExempt:
          'Vous appliquez le <strong>régime standard de franchise de TVA</strong>. Les factures entre vous et Creative Shelter sont établies sans TVA. Suivez ci-dessous à quelle distance vous êtes du plafond.',
        vatNormal:
          'Vous appliquez le <strong>régime normal de TVA</strong>. Les factures entre vous et Creative Shelter sont établies avec TVA.',
      },
      limit: 'Plafond du régime de franchise {{year}}',
      options: {
        vatExempt: {
          description: 'Petites entreprises dont le chiffre d’affaires est inférieur à 25 000 €',
        },
        vatNormal: {
          description: 'Entreprises dont le chiffre d’affaires dépasse 25 000 €',
        },
      },
      title: 'Régime de TVA',
      toggle: {
        vatExempt: 'Franchise de TVA',
        vatNormal: 'Assujetti à la TVA',
      },
      toggleDescription: {
        vatExempt: 'Petites entreprises dont le chiffre d’affaires est inférieur à 25 000 €',
        vatNormal: 'Entreprises dont le chiffre d’affaires dépasse 25 000 €',
      },
      tooltip: 'Si votre chiffre d’affaires dépasse 25 000 €, vous ne pouvez plus appliquer le régime standard de franchise de TVA.',
      totalRevenueInYear: 'Chiffre d’affaires total {{ year }}',
      yearSelector: {
        ariaLabel: 'Sélectionnez l’année pour laquelle vous voulez consulter le plafond de chiffre d’affaires.',
      },
    },
  },
  prompts: {
    verifyAddress: {
      change: {
        actions: {
          back: 'Retour',
          mail: 'Envoyez-nous un e-mail',
        },
        description:
          'Vous avez déménagé ? Faites-le-nous savoir ! Envoyez un e-mail avec votre nouvelle adresse et nous l’adapterons dans votre profil.',
        kboMessage:
          'Conseil ! Communiquez aussi votre nouvelle adresse à la Banque-Carrefour des Entreprises (via <myEnterpriseLink>My Enterprise</myEnterpriseLink>).',
        mailLink: 'mailto:service@creativeshelter.be?subject=Nouvelle adresse&body=Bonjour%0D%0A%0D%0AMa nouvelle adresse est',
        title: 'Modifier l’adresse, s’il vous plaît !',
      },
      verify: {
        actions: {
          confirm: 'Oui, c’est correct !',
          edit: 'Pas encore correct, à modifier !',
          refresh: 'Récupérer à nouveau les données',
        },
        description: 'Les données ci-dessous figurent dans votre profil. Pouvez-vous vérifier votre adresse ?',
        errors: {
          refreshKboFailed: 'Vos données ne peuvent pas être récupérées auprès de la Banque-Carrefour des Entreprises pour le moment.',
        },
        title: 'Vérifiez votre adresse',
      },
    },
  },
  tabs: {
    company: 'Données de l’entreprise',
    email: 'Notifications',
    integrations: 'Intégrations',
    invoice: 'Paramètres de facturation',
    profile: 'Profil',
  },
  unsavedChanges: {
    description: 'Enregistrez vos modifications avant de continuer, ou ignorez-les pour continuer sans enregistrer.',
    discard: 'Ignorer les modifications',
    save: 'Enregistrer les modifications',
    title: 'Vous avez des modifications non enregistrées',
  },
};
